export enum AnimationAssetNames {
	Alert = "alert",
	Box = "box",
	InteractableIntersetion = "interactable-intersection"
}
